import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as Location } from './8-pos.svg';
import { ReactComponent as Calendar } from './7-pos.svg';
import { ReactComponent as Cost } from './1-pos.svg';
import { ReactComponent as Days } from './6-pos.svg';
import styled from 'styled-components';

const Icon = styled.div`
  display: flex;
  justify-content: center;
  color: var(--color-primary, #ffe500);

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const Icons = ({ icon }) => {
  const SelectedIcon = () => {
    switch (icon) {
      case 'days':
        return <Days />;
      case 'start':
      case 'calendar':
        return <Calendar />;
      case 'location':
        return <Location />;
      case 'cost':
        return <Cost />;
      default:
        return <></>;
    }
  };

  return (
    <Icon className={'icon'}>
      <SelectedIcon />
    </Icon>
  );
};

Icons.propTypes = {
  icon: PropTypes.string,
};

Icons.defaultProps = {
  icon: '',
};

export default Icons;
